import styled from "@emotion/styled";
import { PopupButton } from "@typeform/embed-react";

export const StyledPopupButton = styled(PopupButton)`
  display: none;
`;
